export default class ReplacementCostsByZipCode {
  constructor(obj) {
    if (obj.replacement_cost_by_zip_codes) {
      this.zip_code = obj.replacement_cost_by_zip_codes.zip_code;
      this.luxury = obj.replacement_cost_by_zip_codes.luxury;
      this.semi_luxury = obj.replacement_cost_by_zip_codes.semi_luxury;
      this.best_std = obj.replacement_cost_by_zip_codes.best_std;
      this.good_std = obj.replacement_cost_by_zip_codes.good_std;
      this.avg_std = obj.replacement_cost_by_zip_codes.avg_std;
      this.min_std = obj.replacement_cost_by_zip_codes.min_std;
    }
  }
}
